module.exports = __webpack_public_path__ + "static/media/7.2fdb1a79.png";